var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 20,
    viewBox: "0 0 45 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8242 11.5075C0.972858 11.5075 0.282714 10.8174 0.282714 9.96606C0.282714 9.1147 0.972859 8.42458 1.82419 8.42458L34.6197 8.42458C35.4082 8.42458 35.688 7.38061 35.005 6.98638L29.6202 3.87737C28.8823 3.45138 28.6295 2.50792 29.0555 1.77009C29.4815 1.03218 30.425 0.779377 31.1629 1.20536L43.1723 8.13902C43.468 8.30974 43.6858 8.56362 43.8132 8.85411C43.8513 8.94067 43.8972 9.02383 43.9502 9.10214C44.1173 9.34854 44.2149 9.6459 44.2149 9.96606C44.2149 10.2566 44.1345 10.5285 43.9947 10.7605C43.9574 10.8224 43.9244 10.8869 43.8961 10.9534C43.7702 11.2492 43.5507 11.5082 43.2508 11.6813L31.2307 18.6211C30.4956 19.0455 29.5554 18.7936 29.131 18.0584C28.7065 17.3232 28.9584 16.3832 29.6936 15.9587L34.9122 12.9458C35.595 12.5515 35.3153 11.5075 34.5268 11.5075L1.8242 11.5075Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4978,
    height: 43.9322,
    fill: "white",
    transform: "translate(0.282715 19.215) rotate(-90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.6914ca3959eba2c0b9fd36d73a1f92ed.svg";
export { ForwardRef as ReactComponent };